var ctaButtonClass = function () {

    var buttonClass = $(".m-wysiwyg a > span.btn").attr("class");
    $(".m-wysiwyg a > span.btn").parent().addClass(buttonClass);
    $(".m-wysiwyg a > span.btn").removeClass(buttonClass);

};;